const React = require('react');
const noop = require('mn-utils/noop');
const delay = require('mn-utils/delay');
const upperFirst = require('mn-utils/upperFirst');
const map = require('mn-utils/map');
const withState = require('../../../utils/withState');
const Button = require('../Button/E');
const TextFieldK = require('../TextField/K');
const Select = require('../Select/I');
const CustomInterval = require('./CustomInterval');
const {account$} = require("../../../emitters/account");


const TRANSACTION_TYPES = [
  {
    id: 'all',
  },
  {
    id: 'payment_link',
  },
  {
    id: 'terminal',
  },
  {
    id: 'online',
  },
  {
    id: 'refund',
  },
];

const STATUSES = [
  {
    id: 'all',
  },
  {
    id: 'completed',
  },
  {
    id: 'pending',
  },
  {
    id: 'requested',
  },
  {
    id: 'failed',
  },
  {
    id: 'cancelled',
  },
];

function propName(v) {
  return upperFirst(v.name || v.id).replace('_', ' ');
}

const IntervalFilter = withState((setState, self, onMount) => {
  let _cancel = noop;
  let _search;

  function handleChangeSearchWithReDelay(search) {
    _cancel();
    _cancel = delay(() => {
      const {
        props,
      } = self;
      props.onChange({
        ...props.data,
        search,
      });
    }, 500);
  }
  function handleChangeSearch(e) {
    const searchValue = e.target.value || null;
    setState({
      searchValue,
    });
    handleChangeSearchWithReDelay(searchValue);
  }
  function update() {
    _cancel();
    _cancel = delay(setState, 0, [{
      searchValue: _search,
    }]);
  }

  onMount(() => {
    return () => {
      _cancel();
    };
  });

  return (state, props) => {
    const disabled = props.disabled || false;
    const onChange = props.onChange || noop;
    const data = props.data || {};
    const interval = data.interval || INTERVAL_DAY;

    const search = data.search;
    _search === search || update(_search = search);

    const searchValue = state.searchValue || '';
    const s = props.search || {};
    const searchPlaceholder = s.placeholder || 'Search';

    const _data = {
      ...getDateRange({
        interval: INTERVAL_YEAR,
      }),
      ...data,
    };

    return (
      <div className={'cfx mh-5 pb10 (lt|pb10|ph5)>1 ' + (props.className || '')}>
        {map(INTERVALS, (item) => {
          const id = item.id;

          return (
            <div key={id}>
              <Button
                className="ttU"
                disabled={disabled}
                checked={id === interval}
                onClick={() => {
                  onChange(id === INTERVAL_CUSTOM ? {
                    ..._data,
                    interval: id,
                  } : {
                    ...data,
                    ...getDateRange({
                      interval: id,
                    }),
                    interval: id,
                  });
                }}
              >
                {id === INTERVAL_CUSTOM ? (<CustomInterval
                  disabled={disabled}
                  data={_data}
                  onChange={(state) => {
                    onChange({
                      ...state,
                      interval: id,
                    });
                  }}
                />) : item.name}
              </Button>
            </div>
          );
        })}
        {
          props.disabledSearch ? null : (
            <div>
              <TextFieldK
                className="w249"
                placeholder={searchPlaceholder}
                value={searchValue}
                onChange={handleChangeSearch}
                disabled={disabled}
              />
            </div>
          )
        }
        {
          props.disabledTransactionType ? null : (
            <div>
              <Select
                className="f12 lh17 fw7 w170"
                placeholder="Transaction type"
                propName={propName}
                propValue="id"
                value={data.transactionType || 'all'}
                items={TRANSACTION_TYPES}
                onChange={(id) => {
                  onChange({
                    ...data,
                    transactionType: id !== 'all' ? id : null,
                  });
                }}
              />
            </div>
          )
        }
        {
          props.disabledStatus ? null : (
            <div>
              <Select
                className="f12 lh17 fw7 w170"
                placeholder="Status"
                propName={propName}
                propValue="id"
                value={data.status || 'all'}
                items={STATUSES}
                onChange={(id) => {
                  onChange({
                    ...data,
                    status: id !== 'all' ? id : null,
                  });
                }}
              />
            </div>
          )
        }
      </div>
    );
  };
});


const INTERVAL_DAY = IntervalFilter.INTERVAL_DAY = 'day';
const INTERVAL_WEEK = IntervalFilter.INTERVAL_WEEK = 'week';
const INTERVAL_MONTH = IntervalFilter.INTERVAL_MONTH = 'month';
const INTERVAL_YEAR = IntervalFilter.INTERVAL_YEAR = 'year';
const INTERVAL_ALL_TIME = IntervalFilter.INTERVAL_ALL_TIME = 'all-time';
const INTERVAL_CUSTOM = IntervalFilter.INTERVAL_CUSTOM = 'custom';
const INTERVALS = IntervalFilter.INTERVALS = [
  {
    id: INTERVAL_DAY,
    name: '1 day',
  },
  {
    id: INTERVAL_WEEK,
    name: 'Week',
  },
  {
    id: INTERVAL_MONTH,
    name: 'Month',
  },
  {
    id: INTERVAL_YEAR,
    name: 'Year',
  },
  {
    id: INTERVAL_ALL_TIME,
    name: 'All time',
  },
  {
    id: INTERVAL_CUSTOM,
  },
];


function intervalHandleProvider(days) {
  return () => {
    const dateTo = new Date();
    dateTo.setHours(23, 59, 59, 0);

    const dateFrom = new Date();
    dateFrom.setDate(dateTo.getDate() - days);
    dateFrom.setHours(0, 0, 0, 0);
    return {
      from: dateFrom.getTime(),
      to: dateTo.getTime(),
    };
  };
}


const handleIntervalDay = IntervalFilter.handleIntervalDay = intervalHandleProvider(1);
const handleIntervalWeek = IntervalFilter.handleIntervalWeek = intervalHandleProvider(7);
const handleIntervalMonth = IntervalFilter.handleIntervalMonth = intervalHandleProvider(30);
const handleIntervalYear = IntervalFilter.handleIntervalYear = intervalHandleProvider(365);
const handleIntervalAllTime = IntervalFilter.handleIntervalMonth = () => {
  const acc = account$.getValue() || {onboarding_dt: '2010-01-01'};
  return ({
    from: new Date(acc.onboarding_dt).getTime(),
    to: new Date().getTime()
  })
};
const handleIntervalCustom = IntervalFilter.handleIntervalMonth = (filter) => ({
  from: filter.from,
  to: filter.to,
});
const INTERVAL_HANDLES_MAP = IntervalFilter.INTERVAL_HANDLES_MAP = {
  [INTERVAL_DAY]: handleIntervalDay,
  [INTERVAL_WEEK]: handleIntervalWeek,
  [INTERVAL_MONTH]: handleIntervalMonth,
  [INTERVAL_YEAR]: handleIntervalYear,
  [INTERVAL_ALL_TIME]: handleIntervalAllTime,
  [INTERVAL_CUSTOM]: handleIntervalCustom,
};

function getDateRange(filter) {
  filter = filter || {};
  const search = filter.search;
  const output = (
    INTERVAL_HANDLES_MAP[filter.interval] || handleIntervalCustom
  )(filter);
  search && (output.search = search);
  return output;
}

IntervalFilter.getDateRange = getDateRange;


module.exports = IntervalFilter;
